<template>
  <div>
    <b-field :label="$t(label)">
      <vue-google-autocomplete
        id="address-input"
        classname="address-input"
        types="geocode"
        :placeholder="$t(label)"
        v-on:placechanged="getAddressData"
      >
      </vue-google-autocomplete>
    </b-field>
    <div>
      <p>
        {{ $t('País') }}: {{ addressData.country }} - {{ $t('Localidad') }}:
        {{ addressData.locality }}
      </p>
    </div>
  </div>
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete'
export default {
  components: { VueGoogleAutocomplete },
  props: {
    value: Object,
    label: {
      type: String,
      default: ''
    }
  },
  mounted() {},
  data: () => ({
    addressData: {
      route: null,
      locality: null
    }
  }),
  watch: {
    value: function(val) {
      this.addressData = val
    }
  },
  methods: {
    getAddressData: function(addressData) {
      this.addressData = addressData
      this.$emit('input', this.addressData)
    }
  }
}
</script>

<style scoped>
#address-input {
  width: 100%;
}
</style>
